import React, { useState } from 'react';
import { Modal, Button, Collapse } from 'antd';
import InvoiceLabels from '../../../config/InvoiceLabels.json';
import { ruleTranslations } from '../../../config/Translations';
import { Flow } from '../../../types/flow';
import { LabelDefinition } from '../../../types/label';
import { ModalTitle } from '../../../components/text/Titles';

const { Panel } = Collapse;

type Props = {
  onClose: () => any;
  flow: Flow;
};
const FlowDetailRules = (props: Props) => {
  const { onClose, flow } = props;

  const [openPanels, setOpenPanels] = useState<string[]>([]);

  const renderLabelPanel = (labelDef: LabelDefinition) => {
    if (!flow || !flow.model || !flow.model.info.annotationTypes.includes(labelDef.name)) {
      return null;
    }

    const rulesForField = flow.rules.fields.find(it => it.fieldName === labelDef.name);

    return (
      <Panel
        showArrow={false}
        disabled={!rulesForField || !rulesForField.rules || rulesForField.rules.length === 0}
        extra={
          rulesForField && rulesForField.rules.length > 0 ? (
            <Button type="link" style={{ marginRight: '8px' }}>{`${
              openPanels.includes(labelDef.name) ? 'Hide' : 'Show'
            } ${rulesForField.rules.length} rule(s)`}</Button>
          ) : (
            <span style={{ marginRight: '8px' }}>No rules</span>
          )
        }
        header={<span>{labelDef.translation}</span>}
        key={labelDef.name}
        style={{
          marginBottom: 8,
          borderRadius: '3px',
          border: 'solid 1px #e8e8e8',
          backgroundColor: '#f7f7f7',
        }}>
        {rulesForField && (
          <div style={{ padding: 8 }}>
            <ul>
              {rulesForField.rules.map(it => (
                <li>{ruleTranslations[it]}</li>
              ))}
            </ul>
          </div>
        )}
      </Panel>
    );
  };

  const doneButton = (
    <Button key="submit" type="primary" size="large" onClick={onClose}>
      Done
    </Button>
  );

  const onCollapseChange = (openList: string | string[]) => {
    setOpenPanels(typeof openList === 'string' ? [openList] : openList);
  };

  return (
    <Modal
      maskClosable={true}
      width={768}
      visible={true}
      title={<ModalTitle>Labels and rules</ModalTitle>}
      onOk={onClose}
      onCancel={onClose}
      footer={[doneButton]}>
      <>
        <Collapse
          style={{ backgroundColor: 'white' }}
          bordered={false}
          expandIcon={undefined}
          onChange={onCollapseChange}>
          {InvoiceLabels.map(it => renderLabelPanel(it))}
        </Collapse>
      </>
    </Modal>
  );
};

export default FlowDetailRules;
